import Touchdown from "../../../../football/rules/general/scoring/touchdown";
import DriveEndType from "../../../../football/enums/drive-end-type";
import { isKickoffEnabled } from "../../../../football/utils/context-utils";

export default class FlagTouchdown extends Touchdown {
    async kickoffContextChanges(gameContext) {
        // Without kickoffs a touchdown always happens inside a live drive, so
        // flagChanges below arms the PAT directly. With kickoffs enabled a
        // kickoff-return touchdown can score with no drive open at all, which
        // is exactly what the base hook handles: it arms the drive first and
        // lets CreateDrive arm the PAT once that drive exists.
        if (!isKickoffEnabled(gameContext)) return;

        return super.kickoffContextChanges(gameContext);
    }

    flagChanges(gameContext) {
        if (isKickoffEnabled(gameContext)) return;

        gameContext.triggerPAT = true;
        gameContext.setDriveContext({
            previousDriveEndType: DriveEndType.Touchdown
        });
    }
}
